export var SnapshotObjectType;
(function (SnapshotObjectType) {
    SnapshotObjectType["Visualization"] = "VISUALIZATION";
    SnapshotObjectType["SavedSearch"] = "SAVED_SEARCH";
    SnapshotObjectType["Dashboard"] = "DASHBOARD";
})(SnapshotObjectType || (SnapshotObjectType = {}));
//# sourceMappingURL=snapshot.enum.js.map